module.exports = __webpack_public_path__ + "search.svg?a6dc8a1e33203db096da3c05ca8a66ee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/search.svg
// module id = 66
// module chunks = 0